import React, { Component, forwardRef } from 'react';
import './App.css';

import { Routes, Route, useNavigate, useLocation, useParams,Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Layout from "./modules/Layout/Layout";
import Home from "./modules/Home/Home";
import Content from "./modules/Content/Content"; 
import Product from "./modules/Product/Product";
import NoPage from "./modules/NoPage/NoPage";
import Offline from "./modules/Offline/Offline";
import Loading from "./modules/Loading/Loading";
import Welcome from "./modules/Welcome/Welcome";
import SignIn from "./modules/SignIn/SignIn";
import Products from "./modules/Products/Products.js";
import AccountCreate from "./modules/AccountCreate/AccountCreate";
import i18n from './i18n/i18n';
import {Utils} from './Utils';
import { App as CapacitorApp  } from '@capacitor/app';
import { Keyboard } from '@capacitor/keyboard';
import { PushNotifications } from '@capacitor/push-notifications';
import { Browser } from '@capacitor/browser';

import { AppUpdate, AppUpdateAvailability } from '@capawesome/capacitor-app-update';
import { Capacitor } from '@capacitor/core';

document.addEventListener('click', async (event) => {
  // Megkeressük a legközelebbi <a> taget a kattintás helyén
  const anchor = event.target.closest('a');
  
  if (anchor && anchor.href) {
    const url = anchor.href;

    // Ellenőrizzük, hogy a URL a #from_app szöveggel végződik-e
    if (url.endsWith('#from_app')) {
      event.preventDefault(); // Megakadályozzuk, hogy az appon belül nyíljon meg
      
      // Megnyitás külső rendszerböngészőben (Safari / Chrome)
      await Browser.open({ url: url });
    }
  }
});

const checkForUpdate = async () => {
  if (Capacitor.getPlatform() === 'android') {
    const result = await AppUpdate.getAppUpdateInfo();

    if (result.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE) {
      // Elérhető egy frissítés
      if (result.immediateUpdateAllowed) {
        // Végrehajt egy azonnali frissítést (teljes képernyős)
        await AppUpdate.performImmediateUpdate();
      } else if (result.flexibleUpdateAllowed) {
        // Elindít egy rugalmas frissítést (háttérben töltődik le)
        await AppUpdate.startFlexibleUpdate();
        // ... kezelni a letöltési állapotot és befejezni a frissítést a AppUpdate.completeFlexibleUpdate() hívásával
      }
    }
  }
  // iOS esetén: ha van új verzió, a AppUpdate.openAppStore() segítségével a boltba irányíthatod a felhasználót
};

window.init_push_events = function() {

  console.log('init_push_events');

  window.pendingDeepLinkUrl = null; 

  // Segédfüggvény a navigáció retry logikájához
  const tryHandleDeepLink = () => {
      // Hívd meg a React router kezelődet
      if (window.AppRef && window.AppRef.current && window.AppRef.current.handlePendingDeepLink) {
          console.log('Deep Link elindítva az eseményfigyelőből.');
          window.AppRef.current.handlePendingDeepLink();
      } else {
          // Ha még nincs kész a komponens, 100ms múlva újrapróbáljuk.
          console.warn('AppRef még nem kész. Deep Link kezelés késleltetve 100ms-al.');
          setTimeout(tryHandleDeepLink, 100);
      }
  };

  const appUrlOpen = (url) => {
    setTimeout(() => {
      console.log('appUrlOpen függvény: ', url);

      if (url) {
          console.log('WINDOW LISTENER: Deep Link Custom Event sikeresen elkapva!', url);

          // 1. URL tárolása
          window.pendingDeepLinkUrl = url;
          
          // 2. Készítsünk egy próbálkozó függvényt a React AppRef eléréséhez
          tryHandleDeepLink(); // Használja a globális retry logikát.

      } else {
          console.warn('WINDOW LISTENER: Deep Link esemény érkezett, de az URL hiányzik.');
      }
    }, 1000);
  };

  const pushReceived = (params) => { 
    const title = params.title;
    const body = params.body;
    const deepLinkUrl = params.deepLinkUrl;

    setTimeout(() => {
      console.log('Foreground Push fogadva! Cím:', title, body, deepLinkUrl, window.AppRef.current);

      // Csak akkor folytatjuk, ha az AppRef már elérhető, hogy hívni tudjuk a dialogot
      if (window.AppRef && window.AppRef.current && !!window.AppRef.current.handlePendingDeepLink && !!window.AppRef.current.set_dialog_message) {
          
          // A szöveg, amit megjelenítünk
          const dialogMessage = `<b class="push_title">${title}</b><p class="push_body">${body}</p>`;

          // Opciók a párbeszédablakhoz
          const dialogOptions = {
              // Callback funkció a 'OK' gombhoz
              callback: deepLinkUrl ? () => {
                  // A felhasználó rákattintott, indítjuk a navigációt
                  window.pendingDeepLinkUrl = deepLinkUrl;
                  window.AppRef.current.handlePendingDeepLink();
              } : null,
              
              // Kijelző gombok: 'OK' és 'Mégse'
              cancel: true, // A 'Mégse' gomb megjelenítéséhez
              push_notification: true // Speciális stílus a push értesítéshez
          };

          // 1. MEGJELENÍTÉS a beépített dialog kezelőddel
          // Az App komponensben a set_dialog_message a 'dialog' state-et állítja be
          window.AppRef.current.set_dialog_message(dialogMessage, dialogOptions);

      } else {
          console.warn('Foreground Push érkezett, de az AppRef még nem áll készen a megjelenítésre.');
      }
    }, 1000);
  };

  // !!! Push érkezik az előterében futó alkalmazáshoz.
  window.addEventListener('pushDataReceivedForeground', (e) => {
      const pushData = e.detail.data;
 
      pushReceived({ 
        title: pushData.title, 
        body: pushData.body, 
        deepLinkUrl: pushData.deepLinkUrl 
      });
  });

  // !!! Push érkezik az előterében futó alkalmazáshoz.
  PushNotifications.addListener('pushNotificationReceived', (e) => {
      pushReceived({ 
        title: e.title, 
        body: e.body, 
        deepLinkUrl: e.data.deep_link 
      });
  });

  /*
  // !!! Deep link érkezik, miközben az alkalmazás már fut (elő-, vagy háttérben).
  window.addEventListener('appUrlOpen', (e) => {
      console.log('WINDOW LISTENER: appUrlOpen esemény: ', e);
      appUrlOpen(e.detail.url);
  });
  */

  CapacitorApp.addListener('appUrlOpen', (data) => {
      console.log('WINDOW LISTENER: appUrlOpen esemény: ', data);
      appUrlOpen(data.url);
  });

  // !!! A felhasználó rákattint egy push értesítésre.
  PushNotifications.addListener('pushNotificationActionPerformed', (action) => {
      console.log('GLOBAL LISTENER: pushNotificationActionPerformed esemény érkezett.');
      
      // Logoljuk a teljes akció adatot hibakeresés céljából
      console.log('Push Action Data:', action); 
      
      // Biztonságos hozzáférés az adatokhoz, ami a notification objektumban van
      const payloadData = action.notification?.data || {}; 
      
      // Kinyerés
      const deepLinkUrl = payloadData['deep_link'] || payloadData['url'] || action.notification?.id; 
      
      console.log('Kinyert Deep Link URL (lehet null):', deepLinkUrl);

      if (deepLinkUrl) {
          window.pendingDeepLinkUrl = deepLinkUrl;
          
          // ✅ JAVÍTVA: Retry logika bevezetve a Push Action eseményhez is.
          tryHandleDeepLink();
      } else {
          console.warn('Push Payload nem tartalmaz Deep Link URL-t a várt kulcsok (deep_link/url) alatt.');
      }
  });

  // !!! Alkalmazás indítása deep linkkel (leállított állapotból).
  // ✅ JAVÍTVA: Retry logika bevezetve a getLaunchUrl híváshoz!
  window.tryGetLaunchUrl = async (attempts = 0) => { 
      if (attempts > 300) { // Max. 3 másodpercet várunk (30 * 100ms)
          console.log('GLOBAL LAUNCHURL: A Deep Link időtúllépés miatt elmaradt (max 3s).');
          return;
      }

      const ret = await CapacitorApp.getLaunchUrl();

      //console.log(`GLOBAL LAUNCHURL: getLaunchUrl eredménye (Próba ${attempts}):`, ret);

      if (ret && ret.url) {
          window.pendingDeepLinkUrl = ret.url;
          
          // Elindítjuk a navigációt a meglévő AppRef ellenőrzéssel
          if (window.AppRef && window.AppRef.current && window.AppRef.current.handlePendingDeepLink) {
              console.log('GLOBAL LAUNCHURL: Deep Link sikeresen elindítva.');
              window.AppRef.current.handlePendingDeepLink();
          } else {
              // Ha az AppRef még nem készült el, de a link már megérkezett a Swift kódból.
              //console.warn('GLOBAL LAUNCHURL: AppRef még nem kész. Késleltetett kezelés.');
              setTimeout(() => window.tryGetLaunchUrl(attempts + 1), 200);
          }
      } else {
          // Ha a link még nem elérhető (a Swift 3.0s delay még fut).
          //console.warn('GLOBAL LAUNCHURL: URL még nem érhető el. Újrapróbálkozás...');
          setTimeout(() => window.tryGetLaunchUrl(attempts + 1), 200);
      }
  }

  // Indítjuk a lekérdezést
  //window.tryGetLaunchUrl();
}


CapacitorApp.addListener('appStateChange', (state) => {
  // Csak akkor kell hívni, ha az app előtérbe kerül (a háttérből)
  if (state.isActive) {
    setTimeout(() => {
      console.log('Capacitor App: App előtérbe került (isActive = true). Lekérdezzük a Deep Linket.');
      // Ez hívja meg a globálisan definiált retry logikát.
      window.tryGetLaunchUrl();
    }, 3000);

    Utils.checkRateAppPopup();
  }
});

// fejlesztői célú helper: platformtól és időzítéstől függetlenül, azonnal megjeleníti az értékelő popupot (böngésző konzolból: debugShowRateApp())
window.debugShowRateApp = () => {
  if (window.modals?.PopupRateAppRef?.current) {
    window.modals.PopupRateAppRef.current.show();
  }
};

window.init_push_events();

class App extends Component {

  // ... (a többi osztályváltozó, ref és konstruktor változatlan)
  
  // külső js css fájlok betöltésének nyilvántartása
  third_party = {};

  productsRef = new React.createRef();
  
  dialogRef = new React.createRef();

  // automatikus beléptetéshez szükséges időzítő
  // egy külön ajaxot indítunk autologinIntervalTimeout percenként, hogy a session ne járjon le
  // egy automatikus beléptetés lefut az app indulásakor, ha van remember_hash localstorage-ban
  autologinInterval = null;

  autologinIntervalTimeout = 10 * 60 * 1000; // 10 perc

  // --

  // keyboardWillShow és keyboardWillHide eseményekkor a következő elemek padding-bottom értékét módosítjuk
  // így nyitott billentyűzet esetén a tartalom nem kerül a billentyűzet alá
  handle_keyboard_elements = [
    '.page_welcome .connect',
    '.page_sign_in .content',
    '.page_profile .container_inner',
    '.page_profile_bill_address .container_inner',
    '.page_profile_delivery_address .container_inner',
    '.page_shopping_cart .container_inner',
    '.page_account_create .content',
    '.page_checkout_summary .container_inner',
  ];

  handle_keyboard_elements_original_padding = {};

  // --

  constructor(props) {
    super(props);

    this.state = {
      is_online: window.navigator.onLine,

      // componentDidMount
      initialized: false,

      // get_initial_data
      menus: null, 
      categories: null, 
      is_signed: 0,
      login_ready: 0, // amíg ez 0 addig a betöltő képernyő jelenik meg
      dialog: '',
      dialog_options: {},
      user_data: {},
      home_card_slide: 0,
      sale_url: {},
      subscribed_to_newsletter: 0,
      favorites: [],
      unread_messages: 0,
      navigate_back: false,
      others: {}, // egyéb beállítások backendről
  
      // get_settings
      settings: null, 
      
      current_lang: '',
      appRefReady: false,
      fcm_token: '',
    };

    this.appRef = React.createRef();
  /*
      function setHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
      }

      // A weboldal betöltésekor és átméretezésekor futtassa a funkciót
      window.addEventListener('resize', setHeight);
      setHeight();
  */
  }
  
  // ... (a többi metódus változatlan)

  componentWillUnmount() {
    // Fontos: leiratkozunk az eseményről, amikor a komponens megszűnik
    //CapacitorApp.removeAllListeners();
  }

  handleAppBack()
  {
    let modal_closed = false;
    
    Object.keys(window.modals).map((key,val)=>{
      
      const modal = window.modals[key];
      
      if(modal?.current?.state.show && !modal_closed){
        modal.current.hide();
        modal_closed = true;
        return true;
      }

    });

    if(!modal_closed)
    {
      this.setState({navigate_back:true},()=>{
        this.setState({navigate_back:false});
      })
    }
  }

  openDialog(){
    if (this.dialogRef.current) this.dialogRef.current.showModal();
  };

  closeDialog(){
    if (this.dialogRef.current){
      this.dialogRef.current.close();
      this.setState({dialog:''});
    }
  };

  is_online() {
    return this.state.is_online;
  }

  get_is_signed() {
    return this.state.is_signed;
  }

  get_ugyfelkartya() {
    return this.state.user_data?.ugyfelkartya;
  }


  logout() {
    Utils.get_server_data('', { ajax_event:'logoff', APICACHE:'false' }, { ajax_event: 'logoff' })
      .then((res)=>{
        if (parseInt(res.success) === 1) {

          Utils.localSorageSetWithExpiry('remember_hash_' + this.current_lang, '');

          this.setState({is_signed: 0, logout_now: 1},()=>{
            let user_data = this.state.user_data;
            user_data.ugyfelkartya = null;

            this.setState({logout_now:0, user_data: user_data});

            if(window.AppHeaderRef?.current){
              window.AppHeaderRef.current.setState({signed:0});
            }
            
            if(window.modals.ProfileMenuRef?.current){
              window.modals.ProfileMenuRef.current.setState({is_signed:0});
            }

            setTimeout(() => {
              window.location.href = '/';
            }, 200);
          });
        }
      });
  }

  autoLoginInterval() { //console.log('autoLoginInterval 1');
    if (this.autologinInterval) {
      clearInterval(this.autologinInterval);
    }

    this.autologinInterval = setInterval(() => { 
      const remember_hash = Utils.localSorageGetWithExpiry('remember_hash_' + this.current_lang);

      if (!!remember_hash)
      {
        this.login(true, null, remember_hash,()=>{
          if (this.state.is_signed == 0)
          {
            this.setState({signed:1});
          }
        },(resp)=>{

          Utils.localSorageSetWithExpiry('remember_hash_hu', '');

          this.setState({is_signed: 0, logout_now: 1},()=>{
            let user_data = this.state.user_data;
            user_data.ugyfelkartya = null;

            this.setState({logout_now:0, user_data: user_data});

            if(window.AppHeaderRef?.current){
              window.AppHeaderRef.current.setState({signed:0});
            }
            
            if(window.modals.ProfileMenuRef?.current){
              window.modals.ProfileMenuRef.current.setState({is_signed:0});
            }

            window.location.href = '/welcome';
          });
          
        });
      }
     }, this.autologinIntervalTimeout);
  }
  
  login(auto_login_with_hash = false,form_data,stored_hash,success_callback,faild_callback) {
    
    Utils.get_server_data(
      '',
      {
        ajax_event:'login',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'login',
        formData: (form_data ? JSON.stringify(form_data) : ''),
        auto_login_with_hash: auto_login_with_hash ? '1' : '0',
        remember_hash: stored_hash ? stored_hash : '',
      }
    )
    .then((res)=>{

      if (res.success)
      {

        if(window.AppHeaderRef?.current){
          window.AppHeaderRef.current.setState({signed:1});
        }
        
        if(window.modals.ProfileMenuRef?.current){
          window.modals.ProfileMenuRef.current.setState({is_signed:1});
        }
                 
        // ha bejelölte a checkboxot és php oldalon sikerült is a hírlevél feliratkozás, akkor rögzítjük localstorage-ban, hogy a következő loginnál már ne jelenjen meg a checkbox
        if (parseInt(res.subscribed_to_newsletter) === 1) {
          Utils.localSorageSetWithExpiry('login_newsletter_sent_' + this.current_lang, 1, Number.MAX_SAFE_INTEGER);
        }

        // új remember_hash beállítása localstorage-ban
        if (typeof res.remember_hash != 'undefined' && !!res.remember_hash.length)
        {
            Utils.localSorageSetWithExpiry('remember_hash_' + this.current_lang, res.remember_hash, this.remember_me_expire);
        }

        this.setState({
          is_signed: 1, 
          login_ready: 1, 
          user_data: res.user_data,
          unread_messages: res.unread_messages,
          subscribed_to_newsletter: res.subscribed_to_newsletter,
        });
        
        if(typeof success_callback==='function'){
          success_callback(res);
        }
        

        //belépés után lekédezzük a kosarat
        //@todo ha meglesz az güyfélkártya adat akkor itt át kell adni paraméterbe: post_data['select_ugyfelkartya'] = loyalti_code;
        Utils.get_update_shopping_cart(null,true);


      }
      else 
      {
        this.setState({login_ready: 1}, () => {
          
          if(typeof faild_callback==='function'){
            faild_callback(res);
          }
        });
      }

    });
  }


  get_update_shopping_cart(shoppingcart,is_init, selected_card = ''){

    if(shoppingcart===undefined)
    {
      Utils.get_server_data('', { ajax_event:'get_shoppingcart', APICACHE:'false', select_ugyfelkartya: selected_card })
      .then((res)=>{
          const update_state = {};

          update_state['shopping_cart'] = res.shopping_cart;

          if(res.dialog_message){
            update_state['dialog'] = res.dialog_message;
          }

          this.setState(update_state, () => {           
            this.update_cart_components(is_init);
          });

      });
    }
    else
    {
      this.setState({'shopping_cart':shoppingcart}, () => {
        this.update_cart_components(is_init);
      });
    }

  }

  update_cart_components(is_init)
  {
    if(window.modals.PopupAddedToCartRef?.current && !is_init){
      window.modals.PopupAddedToCartRef.current.show(this.state.shopping_cart.pc_sum); 
    }
    
    if(window.AppFooterMenuRef?.current){
      window.AppFooterMenuRef.current.set_shopping_cart(this.state.shopping_cart);
    }

    if(window.modals.ShoppingCartRef?.current){
      window.modals.ShoppingCartRef.current.set_shopping_cart(this.state.shopping_cart);
    }
  }

  set_dialog_message(msg, options = {})
  {
    this.setState({'dialog':msg, 'dialog_options': options},()=>{
      setTimeout(() => {
          this.openDialog();
      }, 2000);
    });
  }

  get_shopping_cart(){
    return this.state.shopping_cart;
  }

  product_fav_add(e, params = {}) 
  {   
    if (e)
    {
      e.preventDefault();
    }

    const favorites = this.state.favorites;
    const product = typeof params.product !== 'undefined' ? params.product : null;
    const on_resolve = typeof params.on_resolve !== 'undefined' ? params.on_resolve : () => {};

    if (product)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'add_favorite',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'add_favorite',
          formData: JSON.stringify({product_id: product.id}),
        }
      )
      .then((res) => {
        product.fav = 1;
        favorites.push(product);

        this.setState({favorites}, () => on_resolve(res, product));
      });
    }
  }

  product_fav_delete(e, params = {}) 
  {   
    if (e)
    {
      e.preventDefault();
    }

    let favorites = this.state.favorites;
    const product = typeof params.product !== 'undefined' ? params.product : null;
    const on_resolve = typeof params.on_resolve !== 'undefined' ? params.on_resolve : () => {};

    if (product)
    {
      Utils.get_server_data(
        '',
        {
          ajax_event:'delete_favorite',
          APICACHE:'false'
        }, 
        {
          ajax_event: 'delete_favorite',
          formData: JSON.stringify({product_id: product.id}),
        }
      )
      .then((res) => {
        favorites = favorites.filter(fav => parseInt(fav.id) !== parseInt(product.id));
        this.setState({favorites}, () => on_resolve(res, product));
      });
    }
  }

  is_favorite_product(product) {
    let result = false;

    if (this.state.favorites)
    {
      this.state.favorites.forEach(fav => {
        if (parseInt(fav.id) === parseInt(product.id))
        {
          result = true;
        }
      })
    }

    return result;
  }

  isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  render() {
    const isAndroid = this.isAndroid();

    // 1. Nincs internet - EZ A RÉSZ TÖKÉLETES, MARADHAT
    if (!this.is_online()) {
      return (
        <div ref={this.appRef} className={"application_wrapper" + (isAndroid ? " is-android" : "")}>
          <Offline />
        </div>
      );
    }

    // 2. Alap adatok töltése - EZ IS TÖKÉLETES, MARADHAT
    if (!this.state.initialized) {
      return (
        <div ref={this.appRef} className={"application_wrapper" + (isAndroid ? " is-android" : "")}>
          <Loading />
        </div>
      );
    }

    // 3. Nincs bejelentkezve, de már lehet - EZ IS JÓ
    if (!this.state.login_ready) {
      return (
        <div ref={this.appRef} className="application_wrapper"><Loading /></div>
      );
    }

    // Feltételes navigáció kezelése a render elején
    if (this.state.logout_now) {
      return <Navigate to="/" />;
    }
    if (this.state.navigate_back) {
      return <Navigate to={-1} />;
    }

    return (
      <div ref={this.appRef} className={"application_wrapper" + (isAndroid ? " is-android" : "")}>
        {this.render_dialog()}

        {/* Az animációs wrapper kívül van */}
        <AnimatePresence mode="wait">
          {/* A Routes belül, a location és key propokkal az animációhoz */}
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route path="welcome/*" element={this.state.is_signed ? <Home /> : <Welcome />} />
              <Route path="sign_in/*" element={<SignIn ref={window.SignInRef} />} />
              <Route path="account_create/*" element={<AccountCreate />} />
              <Route path="content/*" element={<Content />} />
              <Route path="product/*" element={<Product />} />
              <Route path='products/*' element={<Products />} />
              <Route path="*" element={<NoPage />} />
            </Route>
          </Routes>
        </AnimatePresence>
      </div>
    );
  }

  render_dialog() {
    const { dialog, dialog_options } = this.state;

    if (!dialog) return '';

    const okBtnConditionalProps = {};

    okBtnConditionalProps.onClick = () => {
      this.closeDialog();

      if (!!dialog_options.callback) {
        dialog_options.callback();
      }
    };
    
    const processedText = dialog.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
    
    const dialogLines = processedText.split('\n').map((line, index) => {
        // Készítünk egy span-t a HTML tartalommal
        return (
            <React.Fragment key={index}>
                <span dangerouslySetInnerHTML={{ __html: line }} /> 
                {index < processedText.split('\n').length - 1 && <br />}
            </React.Fragment>
        );
    });

    let dialogClassName = dialog_options.push_notification ? 'push-dialog-message' : '';

    return  <dialog id="dialog" ref={this.dialogRef}>
        {/* A <p> tag helyett most a feldolgozott sorokat jelenítjük meg */}
        <p className={dialogClassName}>{dialogLines}</p> 
        <button id="close" {...okBtnConditionalProps} >{i18n.t('shoppingcartMessageDialogClose')}</button>
        {dialog_options.cancel ? <button id="close" onClick={()=>{this.closeDialog()}}>{i18n.t('dialogCancel')}</button> : ''}
    </dialog>;
  }

  handleLaunchUrlOnMount() {
    setTimeout(() => {
      console.log('handleLaunchUrlOnMount');
    
      // A globálisan definiált, retry logikával ellátott lekérdezést hívja.
      // Ez biztosítja, hogy a lekérdezés csak a komponens betöltődése után indul el.
      if (typeof window.tryGetLaunchUrl === 'function') {
          window.tryGetLaunchUrl();
      } else {
          console.log('tryGetLaunchUrl function is not defined globally!');
      }
    }, 1000);
  }

  componentDidMount() {
      // Ez a globális függvény fut le, amit a Java eval() hív
    window.handleEarlyFcmToken = function(token) {
        if (window.AppRef && window.AppRef.current && window.AppRef.current.setState) {
            //console.log("AppRef készen áll. Állapot frissítése...");
            
            // Hívás a framework állapotkezelőjére
            localStorage.setItem('fcm_token_ready', token);
            window.AppRef.current.setState({fcm_token: token});
            
        } else {
            // Ha nem áll készen, beállítunk egy rövid intervallumot
            //console.log("AppRef még undefined. Késleltetett újrapróbálkozás...");
            
            // Késleltessük az újrapróbálkozást, amíg az AppRef létezik (pl. 50ms)
            setTimeout(() => {
                // Rekurzív hívás önmagára
                window.handleEarlyFcmToken(token); 
            }, 1000);
        }
    };
    
    this.handleLaunchUrlOnMount();

    Utils.checkRateAppPopup();

    const remember_hash = Utils.localSorageGetWithExpiry('remember_hash_hu');

    Utils.get_server_data(
      '',
      { 
        ajax_event:'login',
        APICACHE:'false'
      }, 
      {
        ajax_event: 'login',
        formData: '',
        auto_login_with_hash: '1',
        remember_hash: remember_hash,
      }
    )
    .then((res)=>{
      this.after_did_mount();
    }, () => {
      this.after_did_mount();
      this.setState({is_signed:0}, () => {
         window.location.href = '/';
      });
    });

    if (Capacitor.isNativePlatform()) {
        //checkForUpdate();
    }

    this.autoLoginInterval(); // automatikus beléptetés időzítő elindítása

    // 🛑 TÖRÖLVE: A handlePendingDeepLink HÍVÁS ITT TÖRLÉSRE KERÜLT, MERT KÉTSZER HÍVÓDIK A RENDER FOLYTATÁSÁTÓL FÜGGŐEN.
    // EZT MOST MÁR A PUSH ESZKÖZÖK KEZELIK A RETRY LOGIKÁVAL.

    this.handle_keyboard_events(); // billentyűzet események kezelése
  }

  after_did_mount(callback = () => {}) {

    //console.log('this.state.initialized', this.state.initialized)
    if(!this.state.initialized) 
    {
      this.state.initialized = true;

      this.current_lang =  i18n.resolvedLanguage;
 
      Utils.setCookie('dorko-react-app-version', process.env.REACT_APP_JS_VERSION, 0); 

      Utils.get_server_data('',{'ajax_event':'get_initial_data','APICACHE':'false'}).then((resp_initial)=>{

        let favorites = resp_initial.favorites?.products?.list?.products;
 
        if (!favorites)
        {
          favorites = [];
        }

        //console.log('after get_initial_data', resp_initial);

        this.setState({

          is_signed: parseInt(resp_initial.logged_in) == 1 ? 1: 0,
          login_ready: parseInt(resp_initial.logged_in) == 1 ? 1: 0,
          menus: resp_initial.menus ? resp_initial.menus : [],
          categories: resp_initial.categories ? resp_initial.categories : [],
          shopping_cart: resp_initial.shopping_cart ? resp_initial.shopping_cart : [],
          subscribed_to_newsletter: resp_initial.subscribed_to_newsletter,
          user_data: resp_initial.user_data ? resp_initial.user_data : {},
          home_card_slide: parseInt(resp_initial.home_card_slide) == 1 ? 1: 0,
          sale_url: resp_initial.sale_url,
          favorites: favorites, 
          others: resp_initial.others ? resp_initial.others : {},
          unread_messages: parseInt(resp_initial.unread_messages),

        }, () => {
          //console.log('after setState', resp_initial);

          this.get_update_shopping_cart(undefined,true);

  //console.log('before get_settings');

          this.get_settings()
            .then((resp_settings) => {
              
          //console.log('get_settings', resp_settings);

              if(resp_settings.settings){
                this.setState({settings: resp_settings.settings}, () => {

                  this.is_signed = this.state.is_signed;
                  this.remember_me_expire = resp_settings.settings.remember_me_expire;
                  const remember_hash = Utils.localSorageGetWithExpiry('remember_hash_' + this.current_lang);
                  this.stored_hash = remember_hash ? remember_hash : '';
                  
                  // automatikus beléptetés ha van remember_hash localstorage-ban
                  if (this.stored_hash && !this.is_signed)
                  {
                    // ha php oldalon még nem nincs bejelentkezve
                    this.login(true,null,remember_hash);
                  }
                  else if(this.is_signed)
                  {
                    this.setState({is_signed: 1});
                  }
                  
                  this.setState({login_ready:1});
                  
                  // ha nincs feliratkozva hírlevélre, akkor a legközelebbi loginnál meg kell jeleníteni a checkboxot
                  if (this.state.is_signed)
                  {
                    const login_newsletter_sent = Utils.localSorageGetWithExpiry('login_newsletter_sent_' + this.current_lang);

                    if (parseInt(resp_initial.subscribed_to_newsletter) == 0 && login_newsletter_sent)
                    {
                      Utils.localSorageSetWithExpiry('login_newsletter_sent_' + this.current_lang, 0);
                    }
                    else if(parseInt(resp_initial.subscribed_to_newsletter) == 1) {
                      Utils.localSorageSetWithExpiry('login_newsletter_sent_' + this.current_lang, 1, Number.MAX_SAFE_INTEGER);
                    }
                  }
                });
              }
            });

            this.handlePendingDeepLink(); // ✅ MEGTARTVA: A komponens betöltődése utáni utolsó esély a link kezelésére

            callback();
        });

      });

      this.init_events();
    }
  }

  reload_user_data() {
    Utils.get_server_data('',{'ajax_event':'get_initial_data','APICACHE':'false'}).then((resp_initial)=>{ 
      this.setState({
          user_data: resp_initial.user_data ? resp_initial.user_data : {},
        });
    });
  }

  getFCMToken() {
    const { fcm_token } = this.state;

    return fcm_token;
  }

  handlePendingDeepLink() {
    if (window.pendingDeepLinkUrl) {
        const url = window.pendingDeepLinkUrl;
        window.pendingDeepLinkUrl = null; // Csak egyszer használjuk
        this.handleDeepLink(url);
    }
}

  handleDeepLink(url) {
    try {
        if(url.indexOf('deeplink')!==-1){ 
          // Győződj meg róla, hogy minden szükséges csere megtörténik
          let processedUrl = url.replace('://', '://app.').replace('app.app.', 'app.').replace('/deeplink', '')/*.replace('dorko.hu', 'uf2.netgo-dev.hu')*/;
          const finalUrl = new URL(processedUrl);
          
          // 2. Navigáció: Az URL.href használata helyett próbáljuk a hash-t is kezelni
          if (finalUrl) {
              console.log("Navigáció indítása Universal Linkkel:", finalUrl.href);
              window.location.replace(finalUrl.href);
          }
        } else {
          console.warn("Ismeretlen deeplink formátum, navigáció kihagyva:", url);
        }
    } catch (e) {
        console.warn("Hiba a Universal Link URL feldolgozásakor:", url, e);
    }
  }

  handle_keyboard_events() {
        // A billentyűzet megjelenésekor
        Keyboard.addListener('keyboardWillShow', info => {
          this.handle_keyboard_elements.forEach((selector) => {
            // Keresd meg a tartalmat, aminek a padding-jét módosítani akarod
            const content = document.querySelector(selector);

            if (content) {
              if (typeof this.handle_keyboard_elements_original_padding[selector] === 'undefined')
              {
                this.handle_keyboard_elements_original_padding[selector] = window.getComputedStyle(content).paddingBottom;
              }
              //console.log('keyboardWillShow', selector, this.handle_keyboard_elements_original_padding[selector], info.keyboardHeight);
              content.style.paddingBottom = `${info.keyboardHeight + 20}px`;
              window.dispatchEvent(new Event('resize'));
            }
          });
        });
  
        // A billentyűzet eltűnésekor
        Keyboard.addListener('keyboardWillHide', () => {
          //console.log('keyboardWillHide', this.handle_keyboard_elements_original_padding);
          this.handle_keyboard_elements.forEach((selector) => {
            const content = document.querySelector(selector);

            if (content) {
              // Visszaállítjuk az eredeti padding-bottom értékre
              content.style.paddingBottom = this.handle_keyboard_elements_original_padding[selector];
              window.dispatchEvent(new Event('resize'));
            }
          });
        });
       
    }

  get_settings()
  {
    //először cacheből kérjük le 
    return Utils.get_server_data('',{'CacheFirst':'true','ajax_event':'get_settings'});
  }

  get_favorites() {
    return this.state.favorites;
  }

  set_is_online = function(is_online){
    this.setState({is_online:is_online});
  }

  init_events(){
    
    // Hálózat állapotváltásakor a state frissítése
    window.ononline = ()=>{
      this.set_is_online(true);
    }
    
    // Hálózat állapotváltásakor a state frissítése
    window.onoffline = ()=>{
      this.set_is_online(false);
    }

  }

  change_language = (lang_to='')=>{

    if(!lang_to){
      lang_to = (i18n.resolvedLanguage==='hu') ? 'en' : 'hu';
    }
  
    i18n.changeLanguage(lang_to);
    this.setState({current_lang:i18n.resolvedLanguage})
  }
}

export default App;